module.exports = __webpack_public_path__ + "static/media/content-05.04d49e16.png";